import {resources} from "../../../../core/models/resource/resources";

export const telegramResourceType = resources['telegram'];
export const defaultIcon: string = '../../assets/icons/telegram/account-circle-icon.svg';
